'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TextField = require('@material-ui/core/TextField');
var Autocomplete = require('@material-ui/core/Autocomplete');
var Typography = require('@material-ui/core/Typography');
var ListItem = require('@material-ui/core/ListItem');
var ListItemText = require('@material-ui/core/ListItemText');
var InputAdornment = require('@material-ui/core/InputAdornment');
var styles = require('@material-ui/styles');
var SearchIcon = require('@material-ui/icons/Search');
require('../GoogleMapsProvider/GoogleMapsProvider.js');
var usePlacesAutocomplete = require('../GoogleMapsProvider/usePlacesAutocomplete.js');
var useGeocoder = require('../GoogleMapsProvider/useGeocoder.js');
require('../node_modules/ngeohash/main.js');
require('../ThemeProvider/ThemeProvider.js');
var colors = require('../ThemeProvider/colors.js');
require('../ThemeProvider/theme.js');
var useDebounce = require('../useDebounce/useDebounce.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var Autocomplete__default = /*#__PURE__*/_interopDefaultLegacy(Autocomplete);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var SearchIcon__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon);

var _excluded = ["value", "onChange", "predictionTypes", "countryRestrictions", "componentsMap"];
var useStyles = styles.makeStyles({
  // input: {
  //   ...theme.typography.subtitle1,
  //   padding: 12,
  // },
  checkIcon: {
    marginLeft: 8,
    color: colors.colors.green[500]
  },
  searchIcon: {
    marginLeft: 8
  }
});
var SearchLocationsField = _ref => {
  var {
    value: valueFromProps,
    onChange,
    predictionTypes,
    countryRestrictions,
    componentsMap
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var [options, setOptions] = React__default['default'].useState([]);
  var [isLoading, setIsLoading] = React__default['default'].useState(false);
  var {
    getPlacePredictions
  } = usePlacesAutocomplete.usePlacesAutocomplete();
  var {
    geocode
  } = useGeocoder.useGeocoder();
  var [inputValue, setInputValue] = React__default['default'].useState('');
  var debouncedInputValue = useDebounce.useDebounce(inputValue);
  var [error, setError] = React__default['default'].useState(null);
  /**
   * Passes a selected AutocompleteService value into the
   * geocoder to extract location details.
   *
   * @param {*} event
   * @param {*} value
   */

  function handlePlaceChange(_x, _x2) {
    return _handlePlaceChange.apply(this, arguments);
  }
  /**
   * Renders an AutocompleteService result.
   * @param {*} props
   * @param {*} option
   * @returns
   */


  function _handlePlaceChange() {
    _handlePlaceChange = _rollupPluginBabelHelpers.asyncToGenerator(function* (event, value) {
      if (value !== null && value !== void 0 && value.description) {
        var geocoderRequest = {
          address: value.description
        };

        try {
          var results = yield geocode(geocoderRequest, componentsMap);
          onChange(results);
        } catch (error) {
          var _error$message;

          console.log({
            error
          });
          setError((_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : 'There was a problem using Google Maps');
        }
      }
    });
    return _handlePlaceChange.apply(this, arguments);
  }

  function renderOption(props, option) {
    if (typeof option === 'string') {
      return /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
        variant: "body2",
        color: "textSecondary"
      }, option);
    }

    return /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], props, /*#__PURE__*/React__default['default'].createElement(ListItemText__default['default'], {
      primary: option.structured_formatting.main_text,
      secondary: option.structured_formatting.secondary_text
    }));
  } // Synchronize calls to the AutocompleteService with changes
  // to the debounced input.


  React__default['default'].useEffect(() => {
    if (!debouncedInputValue) {
      return;
    }

    var active = true;
    setIsLoading(true);
    var placesQuery = {
      input: debouncedInputValue
    }; // Conditionally add in the extra query items.
    // See: https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest

    if (countryRestrictions) {
      placesQuery.componentRestrictions = {
        country: countryRestrictions
      };
    }

    if (predictionTypes) {
      placesQuery.types = predictionTypes;
    }

    getPlacePredictions(placesQuery, results => {
      if (active) {
        var newOptions = [];

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
        setIsLoading(false);
        setInputValue('');
      }
    });
    return () => {
      active = false;
    };
  }, [debouncedInputValue, getPlacePredictions]);
  return /*#__PURE__*/React__default['default'].createElement(Autocomplete__default['default'], {
    getOptionLabel: option => typeof option === 'string' ? option : option.description,
    filterOptions: x => x,
    options: options,
    fullWidth: true,
    freeSolo: true,
    autoComplete: true,
    autoSelect: true,
    value: valueFromProps !== null && valueFromProps !== void 0 ? valueFromProps : null,
    disableClearable: true,
    forcePopupIcon: false,
    loading: isLoading,
    noOptionsText: inputValue ? 'Could not find a matching address.' : 'Start typing to search for a matching address.',
    filterSelectedOptions: true,
    onChange: handlePlaceChange,
    onInputChange: (event, newInputValue) => {
      setInputValue(newInputValue);
    },
    renderInput: params => /*#__PURE__*/React__default['default'].createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, params, {
      className: null,
      helperText: error || textFieldProps.helperText,
      error: Boolean(error || textFieldProps.error),
      InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, params.InputProps), {}, {
        className: null,
        startAdornment: /*#__PURE__*/React__default['default'].createElement(InputAdornment__default['default'], {
          position: "start"
        }, /*#__PURE__*/React__default['default'].createElement(SearchIcon__default['default'], null))
      }),
      inputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, params.inputProps), {}, {
        className: classes.input,
        autoComplete: 'new-password'
      })
    })),
    renderOption: renderOption
  });
};
SearchLocationsField.propTypes = {
  value: index.string,
  onChange: index.func,

  /**
   * Array of types that the predication belongs to.
   * https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletePrediction.types
   */
  predictionTypes: index.arrayOf(index.string),

  /**
   * A single country code or an array of country codes that the search results
   * should be limited to.
   * https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#ComponentRestrictions.country
   */
  countryRestrictions: index.oneOfType([index.string, index.arrayOf(index.string)]),
  helperText: index.string,
  componentsMap: index.object
};

exports.SearchLocationsField = SearchLocationsField;
